<template>
  <div class="select _page">
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
      :border="false"
    />
    <div class="box">
      <van-row>
        <van-col span="24">
          <van-cell-group class="border">
            <van-field
              v-model="address"
              required
              label="收货地址"
              placeholder="请输入收货地址"
            />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <van-cell-group>
            <van-field
              v-model="housenumber"
              label="门牌号"
              required
              placeholder="请输入门牌号"
            />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <van-cell-group>
            <van-field label="收货人" required placeholder="请输入收货人">
              <template #input>
                <van-row>
                  <van-col span="12">
                    <input
                      v-model="contacts"
                      type="text"
                      class="phoneinput"
                      placeholder="请输入收货人"
                    />
                  </van-col>
                  <!-- <van-col span="12">
                    <van-radio-group v-model="radio" direction="horizontal">
                      <van-radio name="1">先生</van-radio>
                      <van-radio name="2">女生</van-radio>
                    </van-radio-group>
                  </van-col> -->
                </van-row>
              </template>
            </van-field>
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <van-cell-group>
            <van-field
              v-model="phonenumber"
              label="手机号"
              required
              placeholder="请输入手机号"
              :rules="[{ required: true, message: '请填写手机号码' }]"
            />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row>
        <van-button
          type="primary"
          size="large"
          style="margin-top: 90%"
          @click="handleSaveAdress"
          >保存地址</van-button
        >
      </van-row>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      date: "",
      show: false,
      radio: "",
      active: 0,
      address: "",
      housenumber: "",
      phonenumber: "",
      contacts: "",
      menushow: false,
    };
  },
  methods: {
    onSave() {
      Toast("save");
    },
    onDelete() {
      Toast("delete");
    },
    onChangeDetail(val) {
      if (val) {
        this.searchResult = [
          {
            name: "黄龙万科中心",
            address: "杭州市西湖区",
          },
        ];
      } else {
        this.searchResult = [];
      }
    },
    handleSaveAdress() {
      this.$toast("保存成功");
      this.$router.push({
        path: "/merchants/adminAdress",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box-top {
  display: flex;
  height: 50px;
  border: 1px solid red;
  .left {
    flex: 1;
  }
  .right {
    flex: 1.5;
    height: 45px;
    .time {
    }
  }
}
.width100v {
  width: 100vw;
}
.flex1 {
  flex: 0.5;
}
.right {
  background: #fff;
  height: 480px;
  overflow-y: scroll;
}
.activeClass {
  color: yellow !important;
}
.shopBar {
  max-width: 500px;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 46px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .icon {
    flex: 2.5;
    display: flex;
    .icon-icon {
      width: 70px;
      height: 70px;
      border-radius: 70px;
      background-color: #000;
      margin-left: 20px;
      margin-bottom: 40px;
      border: solid rgb(100, 100, 100) 1px;
    }
    .icon-money {
      display: flex;
      width: 100px;
      font-size: 18px;
      margin-left: 10px;
      // color: blue;
      align-items: center;
      // border: 1px solid red;
    }
    .item {
      height: 1000px;
      width: 100px;
      border: 1px solid red;
    }
  }
  .btn {
    flex: 1;
  }
}
.text {
  font-size: 12px;
}
.phoneinput {
  border: none;
}
input::-webkit-input-placeholder {
  color: #cccccc;
}
.border {
  // border-bottom:1px solid red;
}
.box {
  // border: 1px solid red;
}
</style>
